import React from 'react';

export function ATHeader({children}) {

    return <div className="sticky top-0 pt-3 bg-white pb-2 px-4 z-30">
        {children}
    </div>
}